import { combineReducers } from "redux";
import propertySelectionListReducer from "./propertySelectionListReducer";
import currentPropertyReducer from "./currentPropertyReducer";
import removePropertyReducer from "./removePropertyReducer";
import addPropertyReducer from "./addPropertyReducer";


const propertyListReducer = combineReducers({
    propertySelectionList: propertySelectionListReducer,
    currentProperty: currentPropertyReducer,
    removeProperty: removePropertyReducer,
    addProperty: addPropertyReducer
});

export default propertyListReducer;